import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface QueryRequest {
  bonusCode: string;     // required: F933 bonus code
  empFrom: string;       // employee code range start
  empTo: string;         // employee code range end
  deptFrom: string;      // department code range start
  deptTo: string;        // department code range end
  deptLevel: number;     // 1=dept, 2=div, 3=section, 4=group
  companyType: number;   // 1=Taipei, 2=Kunshan, 3=All
  thanks: string;        // gratitude message
}

export interface BonusDetailRow {
  empCode: string;
  empName: string;
  bonusCode: string;
  bonusName: string;
  deptCode: string;
  deptName: string;
  baseSalary: number;
  specialBonus: number;
  taxRate: number;
  taxAmount: number;
  netAmount: number;
  companyName: string;
}

export interface DeptSummary {
  deptCode: string;
  deptName: string;
  totalBase: number;
  totalSpecial: number;
  totalTax: number;
  totalNet: number;
  empCount: number;
}

export interface QueryResponse {
  details: BonusDetailRow[];
  deptSummary: DeptSummary[];
  totalCount: number;
  grandBase: number;
  grandSpecial: number;
  grandTax: number;
  grandNet: number;
}

export interface BonusCodeOption {
  code: string;
  name: string;
  date: string;
}

export interface LookupResult {
  code: string;
  name: string;
}

// ============================================================
// API Client
// ============================================================

export const pw9337Api = {
  async query(req: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw9337/query', req);
    return res.data;
  },

  async listBonusCodes(): Promise<BonusCodeOption[]> {
    const res = await apiClient.get('/api/pw9337/bonus-codes');
    return res.data.data || [];
  },

  async lookup(type: string, code: string): Promise<LookupResult> {
    const res = await apiClient.get(`/api/pw9337/lookup/${type}/${encodeURIComponent(code)}`);
    return res.data;
  },
};
